import { NavLink } from "react-router-dom";
import { ELNStore } from '../../store';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStore, faCheese, faFileImport, faFileExport, faUser, faLayerGroup, faBroom, faImage, faDatabase, faCalculator, faCalendar } from '@fortawesome/free-solid-svg-icons'

export const AdminMenu = () => {

    const currentUser = ELNStore.useState(s => s.currentUser);

    if (!currentUser || !currentUser.admin) return ''
    return (
        
            <ul className='row'>

                {currentUser.p_admin===2 && <li>
                    <NavLink to="/admin" exact activeClassName="current"><FontAwesomeIcon icon={faFileImport} />&nbsp;&nbsp;Imports</NavLink>
                </li>}
                
                {currentUser.p_admin>=1 && <li>
                    <NavLink to="/admin/shops" exact activeClassName="current"><FontAwesomeIcon icon={faStore} />&nbsp;&nbsp;Shops</NavLink>
                </li>}
                {currentUser.p_admin>=1 && <li>
                    <NavLink to="/admin/products" exact activeClassName="current"><FontAwesomeIcon icon={faCheese} />&nbsp;&nbsp;Products</NavLink>
                </li>}
                {currentUser.p_admin>=1 && <li>
                    <NavLink to="/admin/categories" exact activeClassName="current"><FontAwesomeIcon icon={faLayerGroup} />&nbsp;&nbsp;Categories</NavLink>
                </li>}
                {currentUser.id===12 && currentUser.p_admin>=1 && <li>
                    <NavLink to="/admin/storage" exact activeClassName="current"><FontAwesomeIcon icon={faDatabase} />&nbsp;&nbsp;Storage</NavLink>
                </li>}
                {currentUser.id===12 && currentUser.superadmin ? <li>
                    <NavLink to="/admin/cleaning" exact activeClassName="current"><FontAwesomeIcon icon={faBroom} />&nbsp;&nbsp;Cleaning</NavLink>
                </li> : ''}
                {currentUser.superadmin ? <li>
                    <NavLink to="/admin/users" exact activeClassName="current"><FontAwesomeIcon icon={faUser} />&nbsp;&nbsp;Users</NavLink>
                </li> : ''}
                {currentUser.p_admin>=1 && <li>
                    <NavLink to="/admin/exports" exact activeClassName="current"><FontAwesomeIcon icon={faFileExport} />&nbsp;&nbsp;PW Sales Export</NavLink>
                </li>}
                {currentUser.p_admin>=1 && <li>
                    <NavLink to="/admin/order-exports" exact activeClassName="current"><FontAwesomeIcon icon={faFileExport} />&nbsp;&nbsp;PW Invoice Export</NavLink>
                </li>}
                {currentUser.p_admin>=1 &&<li>
                    <NavLink to="/admin/invoice-exports" exact activeClassName="current"><FontAwesomeIcon icon={faFileExport} />&nbsp;&nbsp;Invoice Export</NavLink>
                </li>}
                {(currentUser.id===12 || currentUser.id===7)   && currentUser.superadmin &&<li>
                    <NavLink to="/admin/year-on-year" exact activeClassName="current"><FontAwesomeIcon icon={faCalendar} />&nbsp;&nbsp;Year on Year</NavLink>
                </li>}
                
            </ul>
    )
}

export default AdminMenu;